export default __webpack_public_path__ + "static/media/plain-sticker-n.729f90dd.png";